import { createTheme } from '@mui/material/styles'

import { palette } from './palette'
import { typography } from './typography'

export const camplusTheme = createTheme({
  palette,
  typography: {
    ...typography,
    htmlFontSize: 10
  },
  shape: {
    borderRadius: 2
  },
  spacing: 8,

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: '10px' // '62.5%',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: '"Barlow", sans-serif',
          fontWeight: 400,
          fontSize: '1.9rem',
          letterSpacing: '-0.02em',
          color: '#4C4C4C'
        }
      }
    },

    MuiTextField: {
      defaultProps: {
        variant: 'standard',
        fullWidth: true,
        size: 'medium'
      },
      styleOverrides: {
        root: {
          '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0, 0, 0, 0.12)'
          },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottomColor: 'rgba(0, 0, 0, 0.24)'
          },
          '& .MuiInputLabel-root': {
            fontFamily: '"Barlow", sans-serif',
            fontWeight: 600,
            fontSize: '1.2rem',
            letterSpacing: '0.02em',
            color: '#B7B7B7',
            transform: 'none',
            position: 'relative'
          },
          '& .MuiInputBase-input': {
            fontFamily: '"Barlow", sans-serif',
            fontWeight: 400,
            fontSize: '1.9rem',
            letterSpacing: '-0.02em',
            color: '#4C4C4C',
            paddingBottom: '0.8rem'
          }
        }
      }
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          paddingBottom: '0.8rem'
        }
      }
    },

    MuiInputLabel: {
      defaultProps: {
        shrink: true
      },
      styleOverrides: {
        root: {
          fontFamily: '"Barlow", sans-serif',
          fontWeight: 600,
          fontSize: '1.2rem',
          letterSpacing: '0.02em',
          color: '#B7B7B7',
          transform: 'none',
          position: 'relative'
        }
      }
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '2.4rem',
          fontFamily: '"Barlow Condensed", sans-serif',
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '3.4rem',
          color: '#2023AA'
        }
      }
    },

    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '0 2.4rem'
        }
      }
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '2.4rem'
        }
      }
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 2,
          textTransform: 'none',
          fontFamily: '"Barlow", sans-serif',
          fontWeight: 500,
          padding: '1.2rem 2.4rem',
          fontSize: '1.6rem',
          lineHeight: 1.7,
          letterSpacing: '-0.01em',
          whiteSpace: 'nowrap'
        },
        sizeLarge: {
          padding: '1.4rem 3.2rem',
          fontSize: '1.6rem'
        }
      }
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          boxShadow: '0 0.2rem 1.2rem rgba(0,0,0,0.08)'
        }
      }
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          height: '1.8rem',
          backgroundColor: 'rgba(0, 0, 0, 0.12)'
        },
        bar: {
          borderRadius: 0,
          backgroundColor: '#A1BBFF'
        }
      }
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          width: '1.6rem',
          height: '1.6rem',
          padding: 0,
          '&.Mui-checked': {
            color: '#2023AA'
          }
        }
      }
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Barlow", sans-serif',
          fontWeight: 600,
          fontSize: '1.9rem',
          letterSpacing: '-0.02em',
          color: '#4C4C4C',
          transform: 'none',
          position: 'relative'
        }
      }
    },

    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          gap: '1.6rem',
          margin: 0,
          padding: '0.8rem 0'
        },
        label: {
          fontFamily: '"Barlow", sans-serif',
          fontWeight: 500,
          fontSize: '1.9rem',
          lineHeight: 1.3,
          color: '#4C4C4C',
          letterSpacing: '-0.02em'
        }
      }
    }
  }
})
